export const REGISTRATION_ROUTE = 'rejestracja';
export const REGISTRATION_ROUTES = {
  FORM: 'formularz',
  REGISTER_SUCCED: 'rejestracja-prawidlowa'
};
